import { EffectAndInvestmentMonthlyBox } from '../../organisms/EffectAndInvestmentMonthlyBox';
import { EvolutionOfBaseBox } from '../../organisms/EvolutionOfBaseBox';
import { InvestmentOTBox } from '../../organisms/InvestmentOTBox';
import { LongTermEffectOTBox } from '../../organisms/LongTermEffectOTBox';
import { RoiBox } from '../../organisms/RoiBox';
import { RoiByMediaBox } from '../../organisms/RoiByMediaBox';
import { RoiOTBox } from '../../organisms/RoiOTBox';
import { ShortTermEffectOTBox } from '../../organisms/ShortTermEffectOTBox';
import { TotalEffectOTBox } from '../../organisms/TotalEffectOTBox';

export const LongTermEffects: React.FC = () => {
  return (
    <>
      <TotalEffectOTBox />
      <ShortTermEffectOTBox />
      <LongTermEffectOTBox />
      <RoiOTBox />
      <InvestmentOTBox />
      <EvolutionOfBaseBox title="Evolution of base" colSpan={12} minH="400px" />
      <EffectAndInvestmentMonthlyBox
        title="Effect and investment monthly"
        colSpan={12}
        minH="400px"
      />
      <RoiBox title="Total ROI" colSpan={12} minH="400px" />
      <RoiByMediaBox
        title="ROI by media monthly"
        timeframe="monthly"
        colSpan={12}
        minH="400px"
      />
      <RoiByMediaBox
        title="ROI by media yearly"
        timeframe="yearly"
        colSpan={12}
        minH="400px"
      />
    </>
  );
};
